import {Component} from "@angular/core";
import {RouteHelper, RouteMapping} from "../misc/route-helper";
import {handleErrors} from "../misc/handle-errors.decorator";
import {ActivatedRoute, Params, Router} from "@angular/router";

@Component({
  templateUrl: "./project-sync-cdf.template.pug",
})
export class ProjectSyncCdfComponent extends RouteHelper {
  error: Error;
  projectId: string;

  paramsMap: RouteMapping[] = [
    {fieldName: "projectId", paramName: "projectId"} as RouteMapping,
  ];

  @handleErrors()
  async loadData(): Promise<any> {
    // const {rows} = await this.projectService.getProjects("0", "1", `id:${this.id}`, false);
    // this.project = rows[0] || {};
  }

  navigate(queryParams: Params, skipLocationChange: boolean = false): Promise<boolean> {
    return this.router.navigate(["project-sync-cdf"], {queryParams, skipLocationChange});
  }

  handleError(event: Event) {
    this.error = event["error"] || undefined;
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
  ) {
    super();
  }
}
